<template>
    <div class="mb-2">
        <div class="list2">
            <div class="col-md-4">
                <img :src="`${base_url}/uploads/${briefProduct.image}`" alt="">
            </div>
            <div class="col-md-5">
                <h3 style="padding: 10px 0;">{{ briefProduct.name }}</h3>
                <div v-html="briefProduct.description"></div>
            </div>
            <div class="card-list col-md-3">
                <div class="card-item-zero"></div>
                <div class="card-item-price">
                    <div>
                        <!-- <span>每箱</span> -->
                        <span style="font-size: 20px;">{{ briefProduct.price }}元</span>
                    </div>
                </div>
                <div class="card-item-add">
                    <a @click.prevent="openForm" class="button" style="flex:1 1;" id="modal-btn">加入購物車</a>
                </div>
            </div>
        </div>
        <cart-item ref="productForm" :product="product"></cart-item>
    </div>
</template>

<script>
    import axios from 'axios';

    import ApiBase from '../components/ApiBase';

    export default {
        extends: ApiBase,
        props: {
            productId: {
                required: true
            },
            briefProduct: {}
        },
        data() {
            return {
                base_url,
                product: {
                    id: undefined,
                    name: '',
                    image: '',
                    description: '',
                    price: 0,
                    fields: []
                }
            };
        },
        mounted() {
            console.log('Product Item is mounted.');
        },
        methods: {
            openForm() {
                this.loadFields();
                this.$refs.productForm.modalShow();
            },
            loadFields() {
                this.dataIsLoading(true);
                axios.get(`${base_url}/api/products/${this.productId}`)
                    .then((...response_success) => {
                        let response_data = response_success[0].data;
                        Object.keys(this.product).forEach(key => {
                            let data_value = response_data[key] ?? null;
                            if (key === 'image')
                                data_value = `${base_url}/uploads/${response_data[key]}`;
                            this.product[key] = data_value;
                        });
                        this.dataIsLoading(false);
                    })
                    .catch((...response_error) => { });
            }
        }
    }
</script>

<style scoped>
    .button {
        background-color: white;
        color: black;
        border: 2px solid #008CBA;
        padding: 5px 20px;
        text-align: center;
        transition-duration: 0.4s;
        cursor: pointer;
    }

    .button:hover {
        background-color: #008CBA;
        color: white;
    }

    @media(max-width:991px) {
        .button {
            padding: 5px;
        }
    }

    .list2 {
        display: flex;
        background: #fff;
        padding: 10px 0;
    }

    @media(max-width:991px) {
        .list2 {
            display: block;
        }
    }

    .card-list {
        display: flex;
        flex-grow: 1;
    }

    @media (min-width: 640px) {
        .card-list {
            flex-direction: column;
            text-align: center;
        }
    }

    .card-item-zero {
        flex-grow: 2;
    }

    @media(max-width:991px) {
        .card-item-zero {
            flex-grow: 0;
        }
    }

    .card-item-price {
        flex-grow: 2;
    }

    .card-item-add {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        flex-shrink: 0;
    }

    .modal-footer {
        justify-content: space-between !important;
    }
</style>